import { Component, OnInit, inject } from '@angular/core';
import { ModalRef } from '../../modal/modal-ref';
import {ModalConfig} from '../../modal/modal-config';
import { NgForm, FormsModule } from '@angular/forms';

import {AngularFireStorage} from '@angular/fire/compat/storage';
import { resizeImage } from '../../image-resize.util';
import { StorageImage } from '../../storage-images.util';
import { StorageImageService } from '../../storage-image.service';
import { ImagePickerComponent } from '../../image-picker/image-picker.component';

@Component({
    selector: 'app-form-add-article',
    templateUrl: './form-add-article.component.html',
    styleUrls: ['./form-add-article.component.scss'],
    imports: [FormsModule, ImagePickerComponent]
})
export class FormAddArticleComponent implements OnInit {
  private modal = inject(ModalRef);
  config = inject(ModalConfig);
  private storage = inject(AngularFireStorage);
  private storageImages = inject(StorageImageService);


  /**
   * input data from the modal, this is set from the config
   */
  public inputData;

  base64Image: string;
  image;
  uploadedImage: File;
  images = [];
  public formData = { title: '', content: '', image: '', bg: '', fileLink: '', imageIsFile: true, picture_text: '', order: 0};

  private id;
  constructor() {
    this.inputData = this.config.data;
  }

  ngOnInit() {
    this.image = this.inputData.content?.attributes?.image;
    this.getSavedImages();
    if (this.inputData.content?.id) {
      this.formData = this.inputData.content.attributes;
      this.id = this.inputData.content.id;
    }
  }


  addImage(event) {
    const file = event.target.files[0];
    const filePath = 'user-images/' + file.name;

    resizeImage(file, 720, 500).then(resized => {
      this.uploadedImage = resized;
      const task = this.storage.upload(filePath, this.uploadedImage);
    });

    this.image = filePath;
  }

  /**
   * Passes the form data out of the modal through the on close method,
   * Only basic validation atm, needs to be extended
   *
   * The type of page is passed through so that the correct api call can be made
   *
   * @param formData
   */

  onAddArticle(formData: NgForm) {
    const formAttributes = formData.form.value;
    formAttributes.image = this.image;
    const data = {type: this.inputData.type, attributes: formAttributes, id: this.id};
    this.modal.close(data);
  }

  getSavedImages() {
    this.storageImages.listSavedImages().then(images => {
      this.images = images;
    }).catch((error) => {
      console.log(error);
    });
  }

  selectImage(imagePath) {
    this.image = imagePath;
  }

  onImageDeleted(img: StorageImage) {
    if (this.image === img.path) {
      this.image = '';
    }
    this.getSavedImages();
  }

}
